import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const FechaEntregaFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='F. ENTREGA' htmlFor='date-fechaEntrega' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='fechaEntrega'>
          {({ field }) => <Form.InputDate {...field} id='date-fechaEntrega' disabled={fIsSubmitting} isInvalid={iTouched && iError} />}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(FechaEntregaFormGroup)
